import { HomeFloorLIcon } from './HomeFloorLIcon';

/**
 * author: GreenTurtwig
 * id D6B418D4-1B34-4E5C-B406-0E27B72DC0AC
 * name home-floor-l
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-floor-l.svg
 * tags
 * - Home Automation 
 */
export const HomeFloorLoftIcon = HomeFloorLIcon;
export default HomeFloorLoftIcon